export default __webpack_public_path__ + "refresh-arrow.png";